import _defineProperty from "C:\\Users\\ADIAZ\\Documents\\4GFLOTANEW\\Erpv2.0\\node_modules\\@babel\\runtime\\helpers\\esm\\defineProperty.js";
import _slicedToArray from "C:\\Users\\ADIAZ\\Documents\\4GFLOTANEW\\Erpv2.0\\node_modules\\@babel\\runtime\\helpers\\esm\\slicedToArray.js";
import _objectWithoutProperties from "C:\\Users\\ADIAZ\\Documents\\4GFLOTANEW\\Erpv2.0\\node_modules\\@babel\\runtime\\helpers\\esm\\objectWithoutProperties.js";
var _excluded = ["bsPrefix", "placement", "className", "style", "children", "arrowProps", "popper", "show"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix, useIsRTL } from './ThemeProvider';
import { getOverlayDirection } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultProps = {
  placement: 'right'
};
var Tooltip = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      placement = _ref.placement,
      className = _ref.className,
      style = _ref.style,
      children = _ref.children,
      arrowProps = _ref.arrowProps,
      _ = _ref.popper,
      _2 = _ref.show,
      props = _objectWithoutProperties(_ref, _excluded);

  bsPrefix = useBootstrapPrefix(bsPrefix, 'tooltip');
  var isRTL = useIsRTL();

  var _ref2 = (placement == null ? void 0 : placement.split('-')) || [],
      _ref3 = _slicedToArray(_ref2, 1),
      primaryPlacement = _ref3[0];

  var bsDirection = getOverlayDirection(primaryPlacement, isRTL);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    ref: ref,
    style: style,
    role: "tooltip",
    "x-placement": primaryPlacement,
    className: classNames(className, bsPrefix, "bs-tooltip-".concat(bsDirection))
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("div", _objectSpread({
      className: "tooltip-arrow"
    }, arrowProps)), /*#__PURE__*/_jsx("div", {
      className: "".concat(bsPrefix, "-inner"),
      children: children
    })]
  }));
});
Tooltip.defaultProps = defaultProps;
Tooltip.displayName = 'Tooltip';
export default Tooltip;